import { Alert as ReactAlert, Label } from '@a-ui/react';
import React from 'react';
import LayoutTile from '../../components/LayoutTile';
import Typography from '../../components/Typography';
import { translate } from '../../i18n';
import { useAuthentication } from '../../state/Authentication';

interface NewsletterEmailProps {}

const NewsletterEmail: React.FC<NewsletterEmailProps> = () => {
  const {
    state: { user },
  } = useAuthentication();

  const emailValue = React.useMemo(() => {
    if (user.email?.candidate) {
      return <Label type="warning">{translate('common.value.pending')}</Label>;
    }

    if (user.emailPrimary) {
      return user.emailPrimary;
    }

    return <Label type="primary">{translate('common.value.missing')}</Label>;
  }, [user]);

  return (
    <>
      {!user.emailPrimary && (
        <div className="u-margin-bottom-xs">
          <ReactAlert>
            <Typography>{translate('newsletters.email.cta')}</Typography>
          </ReactAlert>
        </div>
      )}

      <LayoutTile
        to="/gegevens/aanmeldsleutels/e-mail"
        label={translate('accessKeys.overview.email.title')}
        toLabel={translate('accessKeys.overview.email.action')}
        value={emailValue}
      />
    </>
  );
};

export default NewsletterEmail;
